import { GAME_HEIGHT, GAME_WIDTH, KoodooScene } from './base-scene';

/**
 * Browsers refuse to start audio until the user interacts with the page, so
 * the game opens on a click-to-start gate rather than fighting the policy.
 * See https://developer.chrome.com/blog/autoplay/
 */
export class Bootup extends KoodooScene {
  static readonly KEY = 'Bootup';

  constructor() {
    super(Bootup.KEY);
  }

  preload(): void {
    this.loadBackgrounds(['bg-1-basecolor']);
  }

  create(): void {
    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'bg-1-basecolor');
    this.setCursor('generic');

    const prompt = this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'click to start', {
        fontFamily: 'ARCO_Typography',
        fontSize: '32px',
        color: '#dddddd',
      })
      .setOrigin(0.5);

    this.tweens.add({
      targets: prompt,
      scale: { from: 0.9, to: 1.1 },
      duration: 800,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    this.input.once('pointerup', () => {
      this.scene.start('Intro');
    });
  }
}
